import { apiPost } from '../hooks/apiCall';

const getNotifications = (payload) => {
    return apiPost(`${process.env.REACT_APP_API_HOST}/api/notification/list`, payload)
}

export {
    getNotifications
}